import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Text } from '@components/Restyle';
import Button from '@components/shared/Button/Button';
import Icon from '@components/shared/Icon/Icon';

type Props = {
  onRetry: () => void;
  // A retry is in flight: keep this state up with a spinner on Retry
  retrying?: boolean;
  // This state replaces the whole checkout stack, including the X that
  // CreateSubscription owns, so the caller must supply a way out
  onClose: () => void;
};

export const StripeUnavailable: React.FC<Props> = ({
  onRetry,
  retrying = false,
  onClose,
}) => {
  const { t } = useTranslation('models');

  return (
    <Box flex={1} padding='l' testID='stripe-unavailable'>
      <Box alignItems='flex-end'>
        <Icon
          name='X'
          onPress={onClose}
          accessibilityLabel={t('shared:close')}
        />
      </Box>
      <Box flex={1} alignItems='center' justifyContent='center'>
        <Text variant='labelEmphasized' textAlign='center' marginBottom='xs'>
          {t('payments.stripeUnavailable.title')}
        </Text>
        <Text variant='body' textAlign='center' marginBottom='l'>
          {t('payments.stripeUnavailable.description')}
        </Text>
        <Button
          variant='primary'
          isSmall
          // `compact` drops the label's flex:1 so the button sizes to its label
          // in this content-width column (see ActivityLogUnavailable).
          compact
          paddingHorizontal='l'
          isLoading={retrying}
          onPress={onRetry}
          accessibilityLabel={t('payments.stripeUnavailable.retry')}>
          {t('payments.stripeUnavailable.retry')}
        </Button>
      </Box>
    </Box>
  );
};
